import { create } from 'zustand'
import { LibraryVocabulary } from '@/models.ts'
import useGlobalStore from '@/useGlobalStore.ts'

export enum OnSuccessfulFinalActionMode {
	ADD = 'add',
	EDIT = 'edit',
	DELETE = 'delete',
}

export type SuccessfulFinalActionCallback = (mode?: OnSuccessfulFinalActionMode, item?: LibraryVocabulary) => void

interface ModalState {
	isOpen: boolean
	mode: string // saved or add
	setMode: (mode: string) => void
	data: LibraryVocabulary | null
	setData: (data: LibraryVocabulary) => void
	onSuccessfulFinalAction: SuccessfulFinalActionCallback | null
	setOnSuccessfulFinalAction: (onSuccessfulFinalAction: SuccessfulFinalActionCallback) => void
	onWordAdded: (() => void) | null
	setOnWordAdded: (onWordAdded: () => void) => void
	showModal: () => void
	hideModal: () => void
}

const useWordDetailsModalStore = create<ModalState>((set) => ({
	isOpen: false,
	mode: 'saved',
	setMode: (mode: string) => set({ mode }),
	data: null,
	setData: (data: LibraryVocabulary) => set({ data }),
	onSuccessfulFinalAction: null,
	setOnSuccessfulFinalAction: (onSuccessfulFinalAction: () => void) => set({ onSuccessfulFinalAction }),
	onWordAdded: null,
	setOnWordAdded: (onWordAdded: () => void) => set({ onWordAdded }),
	showModal: () => {
		const globalStore = useGlobalStore.getState
		globalStore().setIsModalVisible(true)
		set({
			isOpen: true,
		})
	},
	hideModal: () => {
		const globalStore = useGlobalStore.getState
		globalStore().setIsModalVisible(false)
		set({
			data: null,
			isOpen: false,
			onSuccessfulFinalAction: null,
			onWordAdded: null,
		})
	},
}))

export default useWordDetailsModalStore
